import React from 'react';
import { FiTrash2, FiEye } from 'react-icons/fi';
import { DataRoomDocument, formatFileSize } from '../../types/dataRoom';
import FileTypeIcon from './FileTypeIcon';

const TrashIcon = FiTrash2 as React.FC<React.SVGProps<SVGSVGElement>>;
const EyeIcon = FiEye as React.FC<React.SVGProps<SVGSVGElement>>;

interface DocumentRowProps {
  document: DataRoomDocument;
  onDelete: (docId: string) => void;
  onView: (doc: DataRoomDocument) => void;
}

const DocumentRow: React.FC<DocumentRowProps> = ({ document, onDelete, onView }) => {
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete(document.id);
  };

  const handleView = (e: React.MouseEvent) => {
    e.stopPropagation();
    onView(document);
  };

  return (
    <div className="su-document-row" onClick={handleView} style={{ cursor: 'pointer' }}>
      {/* Inline-styled wrapper overrides any legacy .su-document-icon
          background so the new pictogram renders without the old
          coloured-tile chrome. */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: 'transparent' }}>
        <FileTypeIcon
          fileType={document.file_type}
          fallbackFilename={document.original_filename}
          size={36}
        />
      </div>
      <div className="su-document-info">
        <div className="su-document-name" title={document.name}>{document.name}</div>
        <div className="su-document-meta">
          {formatFileSize(document.file_size)} • Uploaded {formatDate(document.created_at)}
        </div>
      </div>
      <div className="su-document-actions">
        <button
          className="su-document-view"
          onClick={handleView}
          title="View document"
          aria-label="View document"
        >
          <EyeIcon width={14} height={14} />
        </button>
        <button
          className="su-document-delete"
          onClick={handleDelete}
          title="Delete document"
          aria-label="Delete document"
        >
          <TrashIcon width={14} height={14} />
        </button>
      </div>
    </div>
  );
};

export default DocumentRow;
